/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';



import MarkupViewer from '../../MarkupViewer';
import { setLPDetails } from '../../../slices/createLPSlice';
import FileUploader from '../../FileUploader'
import MarkupChanger from '../../MarkupChanger';
import LayoutChanger from '../../LayoutChanger';


import './WebinarEmailTemplate.css';


const WebinarEmailTemplate = () => {
  const dispatch = useDispatch();
  const lpDetails = useSelector((state) => state.createLp.data)
  const isEditable = useSelector((state) => state.auth.isEditable);
  const isLogged = useSelector((state) => state.auth.isLogged);

  const [editMode, setEditMode] = useState(true);
  const [currentEditSection, setCurrentEditSection] = useState('');
  const [viewUploader, setViewUploader] = useState(false);
  const [viewEditor, setViewEditor] = useState(false);
  const [layout, setLayout] = useState(lpDetails.emaillayout);
  const [markup, setMarkup] = useState('')
  const [viewLayoutChanger, setViewLayoutChanger] = useState(false)


  const [content, setContent] = useState(null)
  const dispatchLayout = (pl) => {
    dispatch(setLPDetails({ emaillayout: pl }))
  }


  const handleClick = (type) => {
    setCurrentEditSection(type)
    if (type === 'HEADER_LOGO' || type === 'HERO_IMAGE' || type === 'FOOTER_LOGO') {
      setViewUploader(true)
    }
    if (type === 'TITLE') {
      setContent(layout.title)
      setViewLayoutChanger(true)
    }
    if (type === 'HERO_CONTENT') {
      setMarkup(layout.heroContent)
      setViewEditor(true)
    }
    if (type === 'ACTION_BTN') {
      setContent(layout?.actionButton)
      setViewLayoutChanger(true)
    }
    if (type === 'FOOTER_CONTENT') {
      setMarkup(layout.footerContent);
      setViewEditor(true)
    }
  }

 const handleCloseEditor = (
  data,
  isWebinar,
  duration,
  webinarTitle,
  webinarType,
  liveWebinarTitle,
  speakersFlag,
  footerContentforLPCamp
) => {

  let obj = {}

  // KEEP OLD LOGIC EXACTLY SAME
  if (currentEditSection === 'TITLE') {
    obj = { heroTitle: data }
  }

  if (currentEditSection === 'HERO_CONTENT') {
    obj = { heroContent: data }
  }

  // ONLY FOOTER RELATED CHANGE
  if (currentEditSection === 'FOOTER_CONTENT') {

    obj = {
      footerContent: data,
      footerContentforLPCamp:
        footerContentforLPCamp || ""
    }
  }

  setViewEditor(false)

  let pl = {
    ...layout,
    ...obj
  }

  setLayout(pl)

  dispatchLayout(pl)
}

  const handleCloseUploader = (data,width,height) => {
    
    if (data) {
      
      let obj = {}
      if (currentEditSection === 'HEADER_LOGO') {
        obj = { headerLogo: { url: data.Location , 
                              width : width ||  '420px', 
                              height : height || null} 
              }
      }
      if (currentEditSection === 'HERO_IMAGE') {
        obj = { heroImage: { url: data.Location , 
                            width : width || '360px' , 
                            height : height || 'null'} 
              }
      }
      if (currentEditSection === 'FOOTER_LOGO') {
        obj = { footerLogo:{ url: data.Location , 
                              width : width || null , 
                              height :height || 'null'} 
              }
      }
      let pl = { ...layout, ...obj }
      setLayout(pl)
      dispatchLayout(pl)
    }
    setViewUploader(false)
  }

  const handleCloseLayoutChanger = (data) => {
    // console.log(data);
    let obj = {}

    if (data) {
      if (currentEditSection === 'TITLE') {
        obj = {
          title: {
            text: data.text,
            backgroundColor: data.backgroundColor,
            textColor: data.textColor,
            subtitle :  data.subtitle || null
          }
        }
      }
      if (currentEditSection === 'ACTION_BTN') {
        obj = {
          actionButton: {
            text: data.text,
            backgroundColor: data.backgroundColor,
            textColor: data.textColor,
            link: data.link
          }
        }
      }
      let pl = { ...layout, ...obj }
      setLayout(pl)
      dispatchLayout(pl)
    }
    setViewLayoutChanger(false)
  }

  useEffect(() => {
    if (isLogged) {
      setEditMode(isEditable)
    } else {
      setEditMode(false)
    }
    if (lpDetails._id) {
      setLayout(lpDetails.emaillayout)
      document.title =lpDetails['emaillayout']['title']['text'];
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lpDetails])


  return (
    <div className="grid pt-5">
      <div className={`md:col-offset-3 md:col-6 col-12 text-center ${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('HEADER_LOGO')) : undefined}>
        <img className="width240" style={{width : layout?.headerLogo?.width || '240px' , height : layout?.headerLogo?.height || 'auto'}} src={layout?.headerLogo?.url} alt="" />
        <hr />
      </div>
      <div className={`md:col-offset-3 md:col-6 col-12 text-center mb-30p ${editMode ? "u-hover--sparkle" : ""}`} style={{ backgroundColor: layout?.title?.backgroundColor }} onClick={editMode ? (() => handleClick('TITLE')) : undefined}>
        <span className="titleText" style={{ color: layout?.title?.textColor }}><strong>{layout?.title?.text}</strong></span>
        <p className="headerSubTitleEM" style={{ color: layout?.title?.textColor}}>{layout?.title?.subtitle}</p>             
      </div>
      <div className={`md:col-offset-3 md:col-6 col-12 text-left heroContent1 pdt-0 mt-30 ${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('HERO_CONTENT')) : undefined}>
        <MarkupViewer htmlString={layout?.heroContent} ></MarkupViewer>
      </div>
        <div className={`md:col-offset-3 md:col-6 col-12 text-center`}>
       <div className={`${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('HERO_IMAGE')) : undefined}>
        <img  className="maxW80 align-astimg"  style={{width : layout?.heroImage?.width || '80% !important' , height : layout?.heroImage?.height || 'auto'}} src={layout?.heroImage?.url} alt="" />
       </div>
        <div className={`md:col-offset-3 md:col-6 col-12 text-center ${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('ACTION_BTN')) : undefined}>
        <a href={`/preview/${lpDetails?._id}/${lpDetails?.name}`} className="actionBtn" style={{ backgroundColor: layout?.actionButton?.backgroundColor || "#087d95", color: layout?.actionButton?.textColor || 'white' }}
          >{layout?.actionButton?.text}</a>
      </div>
      <div className={`col-12 text-center ${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('FOOTER_LOGO')) : undefined}>
        <hr />
        <img className="width180"  style={{width : layout?.footerLogo?.width || '180px' , height : layout?.footerLogo?.height || 'auto'}} src={layout?.footerLogo?.url} alt="" />
      </div>
      <div className={`col-12 text-center ${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('FOOTER_CONTENT')) : undefined}>
        <span className="footerText">
          <MarkupViewer htmlString={layout?.footerContent}></MarkupViewer></span>
          {!window.location.pathname.includes('preview-email') &&
    layout?.footerContentforLPCamp && (
      <div style={{ marginTop: "20px" }}>
        <MarkupViewer
          htmlString={layout?.footerContentforLPCamp}
        />
      </div>
  )}
      </div>
      </div>
    
      {viewUploader && <FileUploader open={viewUploader} handleCloseUploader={handleCloseUploader}></FileUploader>}
      {viewEditor && <MarkupChanger open={viewEditor} text={markup} handleCloseEditor={handleCloseEditor}></MarkupChanger>}
      {viewLayoutChanger && <LayoutChanger open={viewLayoutChanger} data={content} handleCloseLayoutChanger={handleCloseLayoutChanger}></LayoutChanger>}
    </div>
  )
}

export default WebinarEmailTemplate